if (!window.expressCheckout99Bound) {
  window.expressCheckout99Bound = true;

  function updateCartCount99(count) {
    document.querySelectorAll('[data-cart-flyout-99-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-express-checkout]');
    if (!button) return;

    event.preventDefault();

    const form = button.closest('product-form-99');
    if (!form) return;

    const variantIdInput = form.querySelector('.product-variant-id');
    const variantId = variantIdInput ? variantIdInput.value : button.dataset.variantId;

    if (!variantId) return;

    const quantityInput = form.querySelector('[name="quantity"]');
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    const errorWrapper = form.querySelector('.product-form__error-message-wrapper');
    const errorMessage = form.querySelector('.product-form__error-message');

    button.disabled = true;
    button.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: quantity }]
      })
    })
      .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) {
          throw new Error(data.description || data.message || 'Could not add item to cart');
        }
        return fetch('/cart.js').then((res) => res.json());
      })
      .then((cart) => {
        updateCartCount99(cart.item_count);
        window.location.href = '/checkout';
      })
      .catch((error) => {
        button.disabled = false;
        button.classList.remove('is-loading');
        if (errorWrapper && errorMessage) {
          errorMessage.textContent = error.message;
          errorWrapper.hidden = false;
        }
      });
  });

  // Refresh the count if the browser restores this page from bfcache
  // (e.g. hitting back from /checkout) instead of reloading it.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => updateCartCount99(cart.item_count));
  });
}